import PropTypes from "prop-types";
import { useEffect } from "react";

import { ventilstillingsdetalj } from "../../../constants/titles";
import { toNorwegianDatetime } from "../../../utils/date";
import VentilstillingsdetailBilderContainer from "./VentilstillingsdetailBilderContainer";

const waitForImagesToLoad = (timeoutMs = 6000) =>
  new Promise((resolve) => {
    const timeoutId = setTimeout(resolve, timeoutMs);

    const checkImages = () => {
      const images = Array.from(document.images);

      if (images.length > 0 && images.every((image) => image.complete)) {
        clearTimeout(timeoutId);
        resolve();
        return;
      }

      setTimeout(checkImages, 200);
    };

    checkImages();
  });

const formatDateTime = (date) =>
  date ? toNorwegianDatetime(date).format("DD.MM.YYYY HH:mm") : undefined;

const VentilstillingsdetailUtskrift = ({
  ventilstilling,
  getVentilstilling,
}) => {
  const dato = formatDateTime(ventilstilling.dato);
  const planlagtOppfolgingDato = formatDateTime(
    ventilstilling.planlagtOppfolgingDato,
  );
  const oppfolgingDato = formatDateTime(ventilstilling.oppfolgningDato);

  useEffect(() => {
    const id = JSON.parse(sessionStorage.getItem("printData"));

    sessionStorage.removeItem("printData");
    document.title = ventilstillingsdetalj(id);

    getVentilstilling(id);
  }, [getVentilstilling]);

  useEffect(() => {
    if (!ventilstilling?.id) {
      return;
    }

    let cancelled = false;

    const printWhenReady = async () => {
      await waitForImagesToLoad();

      if (cancelled) {
        return;
      }

      window.print();
      window.close();
    };

    printWhenReady();

    return () => {
      cancelled = true;
    };
  }, [ventilstilling?.id]);

  return (
    <div>
      <div>
        <h1>Ventilstillingsdetaljer</h1>
        <div className="fake-label" style={{ fontSize: 16 }}>
          {`${dato} for kjennemerke ${ventilstilling.kjennemerke}`}
        </div>
      </div>

      <div>
        <h2>Generelt</h2>
        <div>Dato: {dato}</div>
        <div>Status: {ventilstilling.status}</div>
        <div>Ileggelsesnummer: {ventilstilling.ileggelsesnummer}</div>
        <div>Planlagt oppfølgning: {planlagtOppfolgingDato}</div>
        <div>Oppfølgning: {oppfolgingDato}</div>
        <div>Tjenestenummer: {ventilstilling.tjenesteNummer}</div>
      </div>

      <div>
        <h2>Adresse</h2>
        <div>Gate: {ventilstilling.gatenavn}</div>
        <div>Husnummer: {ventilstilling.gatenummer}</div>
        <div>Ved nr.: {ventilstilling.vedGatenummer}</div>
        <div>Ved: {ventilstilling.vedGate}</div>
      </div>

      <div>
        <h2>Kjøretøy</h2>
        <div>Kjennemerke: {ventilstilling.kjennemerke}</div>
        <div>Kjøretøytype: {ventilstilling.kjoretoyType}</div>
        <div>Fabrikkmerke: {ventilstilling.fabrikkmerke}</div>
        <div>Annen informasjon: {ventilstilling.annetinformasjon}</div>
      </div>

      <div>
        <h2>Ventilstillinger</h2>
        <div>VF: {ventilstilling.ventilVf}</div>
        <div>HF: {ventilstilling.ventilHf}</div>
        <div>VB: {ventilstilling.ventilVb}</div>
        <div>HB: {ventilstilling.ventilHb}</div>
      </div>

      {ventilstilling?.id && (
        <VentilstillingsdetailBilderContainer
          ventilstillingId={ventilstilling.id}
        />
      )}
    </div>
  );
};

VentilstillingsdetailUtskrift.propTypes = {
  ventilstilling: PropTypes.object,
  getVentilstilling: PropTypes.func.isRequired,
};

export default VentilstillingsdetailUtskrift;
